import styled, { css } from 'styled-components';
import media from '../../../constants/media';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;

	${media.mobileAndTabletOnly`
        margin-bottom: 2rem;
        justify-content: center;
	`};

	${media.desktopSmall`
		align-items: flex-start;
		flex-direction: column;
	`};
`;

export const StepWrapper = styled.div`
	display: flex;
	justify-content: center;
	position: relative;
	width: 12rem;

	${media.desktopSmall`
		flex-direction: column;
		justify-content: flex-start;
		width: auto;
	`};
`;

export const StepInner = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	${media.desktopSmall`
		flex-direction: row;
	`};
`;

export const StepBubbleOuter = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 4.1rem;
	height: 4.1rem;
	border-radius: 100%;
	transition: background-color 200ms;
	cursor: pointer;

	${({ last }) =>
		last &&
		css`
			cursor: default;
		`};

	${({ active }) =>
		active &&
		css`
			background-color: #fe8e93;
		`};

	${({ fulfilled }) =>
		fulfilled &&
		css`
			background-color: #89deea;
		`};

	${({ disabled }) =>
		disabled &&
		css`
			pointer-events: none;
		`};

	${media.desktopSmall`
		margin-right: 1.5rem;
	`};
`;

export const StepBubble = styled.div`
	display: flex;
	justify-content: center;
	width: 2.9rem;
	height: 2.9rem;
	border-radius: 100%;
	font-size: 1.6rem;
	background-color: ${({ theme }) => theme.colors.grayLighter3};
	color: #fff;
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	transition: background-color 200ms;
	line-height: 2.8rem;

	${({ active, theme }) =>
		active &&
		css`
			background-color: ${theme.colors.primary};
		`};

	${({ fulfilled, theme }) =>
		fulfilled &&
		css`
			background-color: ${theme.colors.secondary};
		`};
`;

export const StepName = styled.div`
	color: ${({ theme }) => theme.colors.black};
	font-size: 1.4rem;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};

	${media.mobileOnly`
		display: none;
	`};
`;

export const Name = styled.div`
	color: ${({ theme }) => theme.colors.black};
	font-size: 1.4rem;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};

	${media.tablet`
		display: none;
	`};
`;

export const StepConnector = styled.div`
	position: absolute;
	top: 2rem;
	right: -50%;
	width: calc(100% - 0.6rem);
	height: 2px;
	background-color: ${({ theme }) => theme.colors.borderColor};
	z-index: -1;

	${({ active, theme }) =>
		active &&
		css`
			background-image: linear-gradient(to right, ${theme.colors.primary}, ${theme.colors.borderColor});
		`};

	${({ fulfilled, theme }) =>
		fulfilled &&
		css`
			background-image: linear-gradient(to right, ${theme.colors.secondary}, ${theme.colors.primary});
		`};

	${({ fulfilledTotal, theme }) =>
		fulfilledTotal &&
		css`
			background-color: ${theme.colors.secondary};
		`};

	${media.desktopSmall`
		position: static;
		height: 6.5rem;
		width: 2px;
		margin-left: 2rem;
		margin-bottom: -6px;
		margin-top: -6px;

		${({ active, theme }) =>
			active &&
			css`
				background-image: linear-gradient(to bottom, ${theme.colors.primary}, ${theme.colors.borderColor});
			`};

		${({ fulfilled, theme }) =>
			fulfilled &&
			css`
				background-image: linear-gradient(to bottom, ${theme.colors.secondary}, ${theme.colors.primary});
			`};

		${({ fulfilledTotal, theme }) =>
			fulfilledTotal &&
			css`
				background-color: ${theme.colors.secondary};
			`};
	`};
`;
